import { render, staticRenderFns } from "./DataRecordFormButton.vue?vue&type=template&id=118e4f34"
import script from "./DataRecordFormButton.vue?vue&type=script&lang=js"
export * from "./DataRecordFormButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports